import { brand } from '../../theme/themePrimitives';
import React from 'react';
import { Box, Paper } from '@mui/material';
import { Handle, NodeProps, Position } from '@xyflow/react';

const EndConitionNode: React.FC<NodeProps> = () => {
    return (
        <Paper
            sx={{
                backgroundColor: 'black',
                boxShadow: 'none',
                padding: 0,
                margin: 0,
                border: 'none'
            }}
        >
            <Box height="10px" width="10px" bgcolor={brand[300]} borderRadius="20px">
            </Box>
            {/* Input and Output Handles - Invisible but Interactive */}
            <Handle
                type="target"
                position={Position.Top}
                style={{ background: '#555' }}
            />
            <Handle
                type="source"
                position={Position.Bottom}
                style={{ background: '#555' }}
            />
        </Paper>
    );
};

export default EndConitionNode;
